<template>
    <div id="app">
        <ToolBar></ToolBar>
        <LeftAsideBar></LeftAsideBar>
        <RightAsideBar></RightAsideBar>
        <div id="main" :class="['d-flex','flex-column',{active : CTI.pin}]">
            <Header></Header>
            <transition name="fade" mode="out-in">
                <router-view :key="$route.params.ServicePhone" v-if="isRouterAlive" />
            </transition>
            <Footer></Footer>
        </div>
        
    </div>
</template>

<script>
    import Vue from 'vue'
    import firebase from 'firebase/app'
    import 'firebase/messaging'
    import { mapState } from 'vuex'
    import { firestorePlugin } from 'vuefire'
    import Header from './components/Header'
    import Footer from './components/Footer'
    import LeftAsideBar from './components/LeftAsideBar'
    import RightAsideBar from './components/RightAsideBar'
    import ToolBar from './components/ToolBar'

    // Install BootstrapVue
    import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
    import 'bootstrap/dist/css/bootstrap.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'

    const RegistrationTopicURL = '/API/RegistrationTopic'

    // Optionally install plugin
    Vue.use(BootstrapVue)
    Vue.use(IconsPlugin)
    Vue.use(firestorePlugin)

    export default {
        name: 'app',
        data() {
            return {
                token: '',
                AccountID: '',
                isRouterAlive: true
            }
        },
        components: {
            Header,
            Footer,
            LeftAsideBar,
            RightAsideBar,
            ToolBar
        },
        computed: {   //撈出 store.js 裡面的 state.status & state.MemberPhone
            ...mapState(['CTI'])
        },
       created() {
            let _this = this

        },
        watch: {
          
        },
        mounted() {
           
        },
        methods: {
            reload () {
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true))
            },   
          
        },
    }
</script>

<style>

    body {
        color: #FCFCFC;
        width: 100%;
        height: 100vh;
        font-size: 15px;
        font-weight: 400;
        font-family: 'Poppins';
        /*font-family: 'Noto Sans HK','Poppins';*/
    }

        body::-webkit-scrollbar {
            width: 5px;
            background-color: #1d1e24;
            cursor: pointer;
        }

        body::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 0px white;
            background-color: #23262b;
        }


        body:hover::-webkit-scrollbar {
            width: 5px;
            background-color: #1d1e24;
            cursor: pointer;
        }

        body:hover::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
            background-color: #23262b;
        }

    .w-75{
        width:75%;
    }

     .min-height-100{
        min-height:100vh;
    }

    #app {
        display: flex;
    }

    #main {
        width: 100%;
        padding: 22px 30px 22px 125px;
        transition:.3s;
    }

        #main.active {
            padding: 22px 30px 22px 320px;
        }

        :focus {
            outline: -webkit-focus-ring-color auto 0px !important;
        }
   
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
    /*TAG 樣式*/
    .tagNameWrap {
        display: flex;
        flex-wrap: wrap;
    }
    .tagName {
        background: #B5B7BF1c;
        border-radius: 5px;
        padding: 5px 7px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

        .tagName.normalTag {
            color: #B5B7BF;
        }

        .tagName.ImportTag {
            color: #FFDB6E;
        }

    /*屬標手指頭*/
    .cursorPoint{
        cursor:pointer;
    }
    /*不要換行*/
    .white-nowrap {
        white-space: nowrap;
    }

    /*Penal 間隔*/
    .Penal-bottom{
        margin-bottom:30px;
    }
    /*model*/
    .model-bg-gray {
        background: #1D1E24;
        border: 0px;
    }

    .close {
        float: right;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        color: #dadada;
        text-shadow: none;
        opacity: .5;
    }
    /*title字體大小*/
    .font-weight-bold {
        font-weight: 600 !important;
    }

    .PageTitle {
        font-size: 24px;
        font-weight: 500;
    }

    .Penaltitle {
        font-size: 20px;
        font-weight: 500;
    }

    .NumberText {
        font-size: 32px;
    }
    .xl-text{
        font-size:36px;
    }
    .lg-text {
        font-size: 24px;
    }
    .md-text {
        font-size: 15px;
    }

    .sm-text{
        font-size:14px;
    }

    .xs-text{
        font-size:12px;
    }

    /*loading overlay 被景色*/

    .b-overlay .bg-dark {
        background-color: #23262b !important;
    }

    /*被景色*/
    .style-background-gray {
        background: #23262B;
       
    }

    .style-background-blue {
        background: #0090FF;
    }

    .style-background-red {
        background: #FF574F;
    }

    .body-style {
        background: #1D1E24;
    }

    /*Panel 樣式*/

    .Panel-Style {
        border-radius: 25px;
        padding: 30px;
    }

    /* Btn 樣式*/

    .mybtn {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 15px;
        width: 138px;
        height: 40px;
        margin: 30px;
        transition:.3s;
    }

    .defaultStyle {
        background: transparent;
        color: #B5B7BF;
        border: 1px solid #505359;
    }

        .defaultStyle:hover {
            background: #30323B;
            border: 1px solid #93959C;
            color: #B5B7BF;
        }

    .blueStyle {
        background: #0090FF;
        color: #FCFCFC
    }

    .gray-text {
        color: #93959C;
    }

    .white-text{
        color:#FCFCFC
    }

    .orange-text {
        color: #FF955C;
    }

    .green-text {
        color: #58D786;
    }

    .blue-text {
        color: #0090FF;
    }

    @media screen and (max-width:992px) {
        #main {
            padding: 22px 30px 22px 30px;
        }
            #main.active {
                padding: 22px 30px 22px 30px;
            }
        
    }

    @media screen and (max-width:767px) {
        #main {
            width: 100%;
            padding: 22px 20px;
        }
    }

    @media screen and (max-width : 600px) {
        .b-sidebar-body .sidebar-right {
            width: 1200px !important;
        }

        .b-sidebar-body{
            overflow-x: scroll;
        }
    }
    
</style>
